export const environment = {
	production: true,
	url: "https://api-mainsite.policystreet.com",
	motorUrl: "https://api-motor.policystreet.com",
	cdnUrl: "https://cdn.policystreet.com"
};
